<unity-page-container [contentHeader]="$contentHeader()" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>
  @let formGroup = $formGroup();
  <unity-card-new-shared actionName="Create" [formGroup]="formGroup" [formLoading]="$formLoading()" (submitEvent)="onSubmit()">
    <kendo-gridlayout gap="1rem" [cols]="$cols()">
      <kendo-gridlayout-item [col]="1">
        <h2 class="agreement-header">Agreement Details</h2>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item [col]="1">
        <unity-textbox-control displayName="Name" description="Provide the agreement name." [control]="formGroup.controls.name" />
      </kendo-gridlayout-item>
      <kendo-gridlayout-item [col]="1">
        <unity-textarea-control
          displayName="Description"
          description="Provide a description for the agreement."
          [control]="formGroup.controls.description" />
      </kendo-gridlayout-item>
      <kendo-gridlayout-item [col]="1">
        <unity-dropdown-agency-control
          displayName="Business Partner"
          description="Select the business partner this agreement is for."
          [control]="formGroup.controls.agency_id" />
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <unity-dropdown-program-control
          displayName="Program"
          description="Select the program this agreement is for."
          [control]="formGroup.controls.program_id" />
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <unity-multiselect-community-control
          description="Select the communities to include as part of this agreement."
          [control]="formGroup.controls.community_ids" />
      </kendo-gridlayout-item>
      <kendo-gridlayout-item [col]="1">
        <unity-selector-date-control
          displayName="Agreement Date"
          description="Select the agreement date"
          [control]="formGroup.controls.agreement_date" />
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <unity-selector-date-range-control [startControl]="formGroup.controls.start_date" [endControl]="formGroup.controls.end_date" />
      </kendo-gridlayout-item>
      <kendo-gridlayout-item [col]="1">
        <h2 class="agreement-header">Agreement Features</h2>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item [col]="1">
        <unity-radio-confirmation-control
          displayName="Supports Disbursments?"
          description="Select whether this agreement will be used for managing disbursements."
          [control]="formGroup.controls.supports_disbursements" />
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <unity-radio-confirmation-control
          displayName="Supports Reference Files?"
          description="Select whether this agreement will be used for managing reference files."
          [control]="formGroup.controls.supports_reference_files" />
      </kendo-gridlayout-item>
      <kendo-gridlayout-item [col]="1">
        <unity-radio-confirmation-control
          displayName="Supports Forms?"
          description="Select whether this agreement will be used for managing forms."
          [control]="formGroup.controls.supports_forms" />
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <unity-radio-confirmation-control
          displayName="Supports Documents?"
          description="Select whether this agreement will be used for managing documents."
          [control]="formGroup.controls.supports_documents" />
      </kendo-gridlayout-item>
      <kendo-gridlayout-item [col]="1">
        <unity-radio-confirmation-control
          displayName="Supports Clients?"
          description="Select whether this agreement will be used for managing clients."
          [control]="formGroup.controls.supports_clients" />
      </kendo-gridlayout-item>
      @if ($supportsClients()) {
        <kendo-gridlayout-item>
          <unity-radio-confirmation-control
            displayName="Supports Client Expenses?"
            description="Select whether this agreement will be used for managing client expenses."
            [control]="formGroup.controls.supports_client_expenses" />
        </kendo-gridlayout-item>
      }

      @if ($supportsDisbursments() === true) {
        <kendo-gridlayout-item [col]="1">
          <h3 class="agreement-subheader">Disbursement Features</h3>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [col]="1">
          <unity-dropdown-form-schemas-control
            displayName="Disbursement Form Schema"
            description="Select a disbursement form schema to use for this agreement."
            [control]="formGroup.controls.disbursement_form_schema_id"
            [selectable]="$disbursementSchemas()" />
        </kendo-gridlayout-item>
        <kendo-gridlayout-item>
          <unity-textbox-currency-control
            displayName="Award Amount"
            description="Enter the award amount, in dollars."
            [control]="formGroup.controls.award_amount" />
        </kendo-gridlayout-item>
      }
      @if ($supportsClients()) {
        <kendo-gridlayout-item [col]="1">
          <h3 class="agreement-subheader">Client Features</h3>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [col]="1">
          <unity-dropdown-form-schemas-control
            displayName="Client Form Schema"
            description="Select a client form schema to use for this agreement."
            [control]="formGroup.controls.client_form_schema_id"
            [selectable]="$clientSchemas()" />
        </kendo-gridlayout-item>
      }
      @if ($supportsClientExpenses()) {
        <kendo-gridlayout-item [col]="1">
          <h3 class="agreement-subheader">Client Expense Features</h3>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [col]="1">
          <unity-dropdown-form-schemas-control
            displayName="Client Expense Form Schema"
            description="Select a client expense form schema to use for this agreement."
            [control]="formGroup.controls.client_expense_form_schema_id"
            [selectable]="$clientExpenseSchemas()" />
        </kendo-gridlayout-item>
        <kendo-gridlayout-item>
          <unity-textbox-currency-control
            displayName="Maximum Amount to Predict Slots"
            description="Enter the maximum amount that will estimate remaining slots."
            [control]="formGroup.controls.client_standard_allocation_amount" />
        </kendo-gridlayout-item>
        <kendo-gridlayout-item>
          <unity-textbox-currency-control
            displayName="Total Client Program Budget"
            description="Enter the portion of the award that should be distributed to clients."
            [control]="formGroup.controls.client_share_of_award_amount" />
        </kendo-gridlayout-item>
      }
    </kendo-gridlayout>
    <ng-content submit-options>
      <unity-action-cancel-shared [disabled]="false" [action]="returnToDashboardAction" />
    </ng-content>
  </unity-card-new-shared>
</unity-page-container>
